<template>
  <div class="company-credit-record-detail" v-if="projectModel&&projectModel.companyName">
    <div class="detail-header">
      <div class="order-number">
        <h2>
          {{$common.companyCreditRecordType[projectModel.type.toString()]}}详情
        </h2>
      </div>
      <div class="header-actions">
        <ButtonGroup>
          <Button type="default"
            @click="goModify"
            v-if="checkRolePermitted(['监管人','总监管人'])"
            >
            <Icon type="md-create" />
            修改</Button>
          <Button type="default"
            @click="revoke"
            v-if="checkRolePermitted(['监管人','总监管人'])"
            >
            <Icon type="md-close" />
            删除</Button>
          <Button type="default"
            @click="getDetail">
            <Icon type="md-refresh" />
            刷新</Button>
        </ButtonGroup>
      </div>
    </div>
    <table class="brief-table">
      <tbody>
        <tr>
          <td class="title" width="140">企业名称</td>
          <td>
            {{ projectModel.companyName }}
          </td>
          <td class="title" width="140">社会信用代码</td>
          <td>
            {{ projectModel.company.businessLicense }}
          </td>
          <td class="title" width="140">企业类型</td>
          <td>
            {{ $common.companyType[projectModel.companyType.toString()] }}
          </td>
        </tr>
        <tr>
          <td class="title" width="140">项目名称</td>
          <td colspan="5">
            {{ projectModel.projectName }}
            <span class="pull-right" v-if="projectModel.guaranteeOrderNumber">
              <a @click="showGuaranteeInfo=!showGuaranteeInfo">{{!showGuaranteeInfo?'显示':'隐藏'}}保函</a>
            </span>
          </td>
        </tr>
        <tr v-if="showGuaranteeInfo" class="no-hover">
          <td colspan="6" align="center" v-if="!guaranteeModel||!guaranteeModel.orderNumber">加载中...</td>
          <td colspan="6" v-else style="padding:0">
            <table class="detail-table">
              <tr>
                <td class="title">保函编号</td>
                <td>
                  <router-link title="查看保函详情" :to="{name: 'guarantee-detail', params: {orderNumber: guaranteeModel.orderNumber}}">
                    {{guaranteeModel.orderNumber}}
                    <Icon type="md-open" />
                  </router-link>
                </td>
                <td class="title">担保种类</td>
                <td>{{guaranteeModel.varietyName}}</td>
                <td class="title">保函备案状态</td>
                <td>
                  <Tag :color="$common.guaranteeStatusColor[guaranteeModel.status]">
                    {{$common.guaranteeStatus[guaranteeModel.status]}}
                  </Tag>
                </td>
              </tr>
              <tr>
                <td class="title">{{guaranteeModel.gMethod===2?'主':''}}保证人</td>
                <td colspan="3">{{guaranteeModel.guarantor?guaranteeModel.guarantor.name:'-'}}</td>
                <td class="title">社会信用代码</td>
                <td>{{guaranteeModel.guarantor?guaranteeModel.guarantor.businessLicense:'-'}}</td>
              </tr>
              <tr>
                <td class="title">受益人</td>
                <td colspan="3">{{guaranteeModel.beneficiary}}</td>
                <td class="title">社会信用代码</td>
                <td>{{guaranteeModel.beneficiaryBusinessLicense}}</td>
              </tr>
              <tr>
                <td class="title">被保证人</td>
                <td colspan="3">{{guaranteeModel.guaranteed}}</td>
                <td class="title">社会信用代码</td>
                <td>{{guaranteeModel.guaranteedBusinessLicense}}</td>
              </tr>
              <tr v-if="guaranteeModel.gMethod===2">
                <td class="title">保证方式</td>
                <td>{{guaranteeModel.gMethod===0?'独立保证':'联合保证'}}</td>
                <td class="title">联保方案</td>
                <td colspan="3">
                  <ul class="joint-plan">
                    <li>主承：{{guaranteeModel.guarantor.name}}，{{`¥ ${guaranteeModel.amount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元</li>
                    <li v-for="(j,idx) in guaranteeModel.jointGuarantors" :key="idx">
                      联保{{idx+1}}：{{j.guarantor.name}}，{{`¥ ${j.amount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元
                    </li>
                  </ul>
                </td>
              </tr>
              <tr v-if="guaranteeModel.gMethod===2">
                <td class="title">总担保金额</td>
                <td>{{`¥ ${totalGuaAmount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元({{$common.transformNumberIntoCHS(totalGuaAmount/100)}})</td>
                <td class="title">担保费率(%·月)</td>
                <td>{{guaranteeModel.gFeeRate>0?Math.round(guaranteeModel.gFeeRate*100)/100+'%·月':''}}</td>
                <td class="title">保额造价比</td>
                <td>{{Math.round(guaranteeModel.amountCostRatio*10000)/100}}%</td>
              </tr>
              <tr v-if="guaranteeModel.gMethod===0">
                <td class="title">担保金额</td>
                <td>{{`¥ ${guaranteeModel.amount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元({{$common.transformNumberIntoCHS(guaranteeModel.amount/100)}})</td>
                <td class="title">担保费率(%·月)</td>
                <td>{{guaranteeModel.gFeeRate>0?Math.round(guaranteeModel.gFeeRate*100)/100+'%·月':''}}</td>
                <td class="title">保额造价比</td>
                <td>{{Math.round(guaranteeModel.amountCostRatio*10000)/100}}%</td>
              </tr>
              <tr>
                <td class="title">保费总额</td>
                <td>
                  <span v-if="guaranteeModel.fee">
                    {{`¥ ${guaranteeModel.fee/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元({{$common.transformNumberIntoCHS(guaranteeModel.fee/100)}})
                  </span>
                  <span v-else>-</span>
                </td>
                <td class="title">保函起止时间</td>
                <td colspan="3">
                  {{$moment(guaranteeModel.gStartDate).format('YYYY-MM-DD HH:mm:ss')}}
                  &nbsp;~&nbsp;
                  {{$moment(guaranteeModel.gEndDate).format('YYYY-MM-DD HH:mm:ss')}}
                  ({{$moment(guaranteeModel.gEndDate).diff($moment(guaranteeModel.gStartDate), 'days')}}天)
                  <p v-if="guaranteeModel.gEndDateOri">
                    (原始起止时间：{{$moment(guaranteeModel.gStartDate).format('YYYY-MM-DD HH:mm:ss')}}
                  &nbsp;~&nbsp;
                  {{$moment(guaranteeModel.gEndDateOri).format('YYYY-MM-DD HH:mm:ss')}})
                  </p>
                </td>
              </tr>
              <tr>
                <td class="title">上报人</td>
                <td>{{guaranteeModel.opName}}({{guaranteeModel.opContactTel}})</td>
                <td class="title">最后修改</td>
                <td>{{$moment(guaranteeModel.updateTime).format('YYYY-MM-DD HH:mm:ss')}}</td>
                <td class="title">录入时间</td>
                <td>{{$moment(guaranteeModel.createTime).format('YYYY-MM-DD HH:mm:ss')}}</td>
              </tr>
              <tr v-if="[0, 1, 2, 3, 4, 5, 8].indexOf(guaranteeModel.status)>-1">
                <td class="title">预审人</td>
                <td>{{guaranteeModel.preAuditorName}}</td>
                <td class="title">预审时间</td>
                <td colspan="3">{{guaranteeModel.preAuditTime?$moment(guaranteeModel.preAuditTime).format('YYYY-MM-DD HH:mm:ss'):''}}</td>
              </tr>
              <tr v-if="[0, 1, 2, 3, 4, 5].indexOf(guaranteeModel.status)>-1">
                <td class="title">审核人</td>
                <td>{{guaranteeModel.auditorName}}</td>
                <td class="title">审核时间</td>
                <td :colspan="[3, 4, 5].indexOf(guaranteeModel.status)>-1?1:3">{{guaranteeModel.auditTime?$moment(guaranteeModel.auditTime).format('YYYY-MM-DD HH:mm:ss'):''}}</td>
                <td class="title" v-if="[3, 4, 5].indexOf(guaranteeModel.status)>-1">终止时间</td>
                <td v-if="[3, 4, 5].indexOf(guaranteeModel.status)>-1">{{guaranteeModel.terminateTime?$moment(guaranteeModel.terminateTime).format('YYYY-MM-DD HH:mm:ss'):''}}</td>
              </tr>
              <tr v-if="guaranteeModel.terminateReason">
                <td class="title">解除保函的原因</td>
                <td colspan="5">{{guaranteeModel.terminateReason}}</td>
              </tr>
              <tr v-if="[6].indexOf(guaranteeModel.status)>-1&&guaranteeModel.auditReason">
                <td class="title">审核拒绝的原因</td>
                <td colspan="5">{{guaranteeModel.auditReason}}</td>
              </tr>
              <tr v-if="[0, 6].indexOf(guaranteeModel.status)>-1&&guaranteeModel.preAuditReason">
                <td class="title">预审拒绝的原因</td>
                <td colspan="5">{{guaranteeModel.preAuditReason}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td class="title" width="140">原因</td>
          <td colspan="5">
            <div style="white-space: pre;">{{ projectModel.reason }}</div>
          </td>
        </tr>
        <tr>
          <td class="title" width="140">主要事实</td>
          <td colspan="5">
            <div style="white-space: pre;">{{ projectModel.fact }}</div>
          </td>
        </tr>
        <tr>
          <td class="title" width="140">处置结果</td>
          <td colspan="5">
            <div style="white-space: pre;">{{ projectModel.conclusion }}</div>
          </td>
        </tr>
        <tr>
          <td class="title" width="140">发布日期</td>
          <td>
            {{ $moment(projectModel.publishDate).format('YYYY-MM-DD') }}
          </td>
          <td class="title" width="140">发布人</td>
          <td>
            {{projectModel.createUserName }}
          </td>
          <td class="title" width="140">最后修改时间</td>
          <td>
            {{ projectModel.updateTime ? $moment(projectModel.updateTime).format('YYYY-MM-DD HH:mm:ss') : $moment(projectModel.createTime).format('YYYY-MM-DD HH:mm:ss') }}
          </td>
        </tr>
      </tbody>
    </table>
    
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'company-credit-record-detail',
  props: {
  },
  components: {
  },
  data () {
    return {
      loading: false,
      projectModel: {
        tid: null,
        companyName: null,
        companyId: null,
        company: null,
        companyType: null,
        projectId: null,
        projectName: null,
        project: null,
        type: null,
        guaranteeId: null,
        reason: null,
        fact: null,
        conclusion: null,
        publishDate: null,
        createTime: null,
        updateTime: null
      },
      showGuaranteeInfo: false,
      guaranteeModel: null
    }
  },
  watch: {
    showGuaranteeInfo: function (newVal) {
      if (newVal && this.projectModel.guaranteeOrderNumber && (!this.guaranteeModel || !this.guaranteeModel.orderNumber)) {
        this.getGuaDetail(this.projectModel.guaranteeOrderNumber)
      }
    }
  },
  mounted () {
    this.getDetail()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    checkSpvMng (action) {
      if (this.$store.getters.userInfo && this.$store.getters.userInfo.type === 127) {
        return true
      }
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '总监管人') {
        return true
      }
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '监管人') {
        // return this.getSysConfig('ENABLE_SUPV_MNG_GUA')
        // console.log(this.supvPerms[action])
        if (action == 'canModifyProjectRegister') {
          return this.projectModel.createUserId === this.$store.getters.userInfo.id
        }
        if (action == 'canRevokeProjectRegister') {
          return this.projectModel.createUserId === this.$store.getters.userInfo.id
        }
        return this.supvPerms[action]
      }
      return false
    },
    async getDetail () {
      this.loading = true
      this.$Spin.show()
      await Api.CompanyCreditRecord.detail(this.$route.params.companyCreditRecordId)
        .then((payload) => {
          this.projectModel= payload
          this.loading = false
          this.$Spin.hide()
        })
        .catch(err => {
          console.log('err', err)
          this.$Message.error('载入失败!' + err.message)
          this.loading = false
          this.$Spin.hide()
        })
    },
    getGuaDetail (orderNumber) {
      Api.Guarantee.getGuaranteeDetail(orderNumber).then(async (res) => {
        this.guaranteeModel = {
          remarks: null
        }
        Object.assign(this.guaranteeModel, res)
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    revoke () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该记录么？</p>',
        onOk: async () => {
          this.loading = true
          this.doRevoke()
        }
      })
    },
    doRevoke () {
      Api.CompanyCreditRecord.deleteCompanyCreditRecord(this.$route.params.companyCreditRecordId).then((res) => {
        if (res) {
          this.$Message.success('操作成功')
          this.$router.push({name: 'company-credit-record-list'})
        } else {
          this.$Message.error('操作失败')
        }
      }).catch(err => {
        this.$Message.error('操作失败!' + err.message)
      })
    },
    goModify () {
      this.$router.push({name: 'company-credit-record-edit', params: {companyCreditRecordId: this.$route.params.companyCreditRecordId}})
    }
  }
}
</script>

<style lang="less" scoped>
.company-credit-record-detail {
  .detail-header {
    margin-bottom: 20px;
    position: relative;
    .status-badge {
      position: absolute;
      right: 0;
      top: 0;
    }
    .header-actions {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
